<template>
  <div class="option-list-container" ref="optionListContainer">
    <div
      class="option-list-container-target"
      @click="isOpenedLocal = !isOpenedLocal"
    >
      <slot name="optionListTarget" :isOpened="isOpenedLocal"></slot>
    </div>
    <transition name="option-list">
      <div
        class="option-list"
        :style="{
          width: props.width / 16 + 'rem',
        }"
        :class="[calculatePosition]"
        ref="optionList"
        v-if="isOpenedLocal"
      >
        <div class="option-list__header" v-if="optionListHeader">
          <slot name="optionListHeader"></slot>
        </div>
        <div class="option-list__list-items">
          <TirPmScrollbar>
            <div
              class="option-list__items"
              :style="{
                maxHeight: props.maxHeight / 16 + 'rem',
              }"
            >
              <slot name="content" :close="closePopup">
                <p class="option-list__empty-sign">
                  {{ props.isWithoutOptionLabel }}
                </p></slot
              >
            </div>
          </TirPmScrollbar>
        </div>
        <div class="option-list__bottom" v-if="optionListBottom">
          <slot name="optionListBottom"></slot>
        </div></div
    ></transition>
  </div>
</template>

<script lang="ts" setup>
import { useDetectOutsideClick } from "tir-components/composables";
import { TirPmScrollbar } from "tir-pm-scrollbar";
import { PropType, computed, defineProps, ref, useSlots, watch } from "vue";
import { TirPmOptionListPositionEnum } from "./enums";

// const emit = defineEmits<{
//   (eventName: "toggleVisibleOptions", value: boolean): void;
// }>();

const slots = useSlots();

interface IPosition {
  x?: TirPmOptionListPositionEnum;
  y?: TirPmOptionListPositionEnum;
}

/**
 * Есть ли слот для хедера
 */
const optionListHeader = computed(
  () => slots && slots.optionListHeader && slots.optionListHeader()
);
/**
 * Есть ли слот для футера
 */
const optionListBottom = computed(
  () => slots && slots.optionListBottom && slots.optionListBottom()
);

const optionListContainer = ref(null);

/**Отправка состояния видимости опций */
const emits = defineEmits<{
  (e: "checkOpenOptions", value: boolean);
}>();
/**
 * Пропсы
 */
const props = defineProps({
  /**
   * Максимальная высота
   */
  maxHeight: { type: Number as PropType<number>, default: 240 },

  /**
   * Открыто
   */
  isOpened: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Ширина
   */
  width: {
    type: Number as PropType<number | string>,
  },
  /**
   * Дизейбл
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Надпись если нет выриантов выбора
   */
  isWithoutOptionLabel: {
    type: String as PropType<string>,
    default: "Пока ничего нет",
  },
  /**
   * Использовать ли клик-оутсайд для закрытия окна
   */
  isUseClickOutside: { type: Boolean as PropType<boolean>, default: true },
  /**
   * Позиция по горизонтали
   */
  horizontalPosition: {
    type: Object as PropType<IPosition>,
    required: false,
    default(): IPosition {
      return {};
    },
  },
  verticalPosition: {
    type: Object as PropType<IPosition>,
    required: false,
    default(): IPosition {
      return {};
    },
  },
});

const isOpenedLocal = ref(props.isOpened);

const closePopup = () => {
  isOpenedLocal.value = false;
};

watch(
  () => props.isOpened,
  (newState) => {
    isOpenedLocal.value = newState;
  }
);

watch(
  () => isOpenedLocal.value,
  () => {
    emits("checkOpenOptions", isOpenedLocal.value);
  }
);
/**
 * Выведение класса для позиционирования
 */
const calculatePosition = computed(() => {
  if (Object.keys(props.horizontalPosition).length) {
    return `option-list--${props.horizontalPosition.x}-${props.horizontalPosition.y}-horizontal-position`;
  } else if (Object.keys(props.verticalPosition).length) {
    return `option-list--${props.verticalPosition.x}-${props.verticalPosition.y}-vertical-position`;
  } else {
    return "option-list--full-width-bottom";
  }
});

if (props.isUseClickOutside) {
  useDetectOutsideClick(optionListContainer, () => {
    isOpenedLocal.value = false;
  });
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
